<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/planned-maintenance/spare-parts"></back-button>
          Add Spare Part
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">
            <router-link :to="`/planned-maintenance/spare-parts`"
              >Spare Parts</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Vessel</label>
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.vessel_id"
                      :suggestions="vessels"
                      placeholder="Select vessel"
                    ></my-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Spare Name</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.spare_name"
                      class="form-control"
                      placeholder="Spare name"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">SFI code</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.sfi_code"
                      class="form-control"
                      placeholder="SFI code"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Spare Code</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.spare_code"
                      class="form-control"
                      placeholder="Spare code"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Make</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.make"
                      class="form-control"
                      placeholder="Make"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Part Number</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.part_number"
                      class="form-control"
                      placeholder="Part Number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Draw Number</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.draw_number"
                      class="form-control"
                      placeholder="Draw Number"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Model Number</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.model_number"
                      class="form-control"
                      placeholder="Model Number"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Serial Number</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.serial_number"
                      class="form-control"
                      placeholder="Serial Number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Measure</label>
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.measure_id"
                      :suggestions="measures"
                      placeholder="Select measure"
                    ></my-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Expiry Date</label>
                  <div class="col-sm-8">
                    <my-datepicker
                      :date.sync="form.expiry_date"
                      placeholder="Enter Expiry Date"
                    ></my-datepicker>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Location On Board</label
                  >
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.location_on_board_id"
                      :suggestions="location_on_boards"
                      placeholder="Select location on board"
                    ></my-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Machinary Group</label>
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.machinaery_group_id"
                      :suggestions="machinaryGroups"
                      placeholder="Select Machinary Group"
                    ></my-select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Related machinery</label
                  >
                  <div class="col-sm-8">
                    <my-select
                      disableFormControl="true"
                      :selection.sync="form.related_machinary_id"
                      :suggestions="relatedMachinaries"
                      placeholder="Select Machinary Group"
                    ></my-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-1">
                <div class="row mb-1">
                  <label class="col-sm-12 col-form-label">Is Critical</label>
                  <div class="form-check form-switch mb-2">
                    <input
                      type="checkbox"
                      v-model="form.is_critical"
                      class="form-check-input"
                      id="formSwitch1"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-1">
                <div class="row mb-1">
                  <label class="col-sm-12 col-form-label">Is SOPEP</label>
                  <div class="form-check form-switch mb-1">
                    <input
                      type="checkbox"
                      v-model="form.is_sopep_item"
                      class="form-check-input"
                      id="formSwitch1"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">Remarks</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.remarks"
                      class="form-control"
                      placeholder="Remarks"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Attachment</label>
                  <div class="col-sm-8">
                    <input
                      type="file"
                      ref="file"
                      name="file"
                      multiple
                      class="form-control"
                      placeholder="Remarks"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <h4><i class="link-arrow" data-feather="edit"></i> Procurement</h4>
            <hr />
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Average Price (USD)</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.average_price"
                      class="form-control"
                      placeholder="Average Price"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Latest Price (USD)</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.average_price"
                      class="form-control"
                      placeholder="Latest Price"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Current Price (USD)</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.average_price"
                      class="form-control"
                      placeholder="Current Price"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">Supplier Name</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.supplier_name"
                      class="form-control"
                      placeholder="Supplier Name"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label">PO Number </label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.po_number"
                      class="form-control"
                      placeholder="PO Number"
                      readonly
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <h4>
              <i class="link-arrow" data-feather="edit"></i>Quantities on board
            </h4>
            <hr />
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Minimum alarm level</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.min_alarm_level"
                      class="form-control"
                      placeholder="Minimum alarm level"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Maximum alarm level</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.max_alarm_level"
                      class="form-control"
                      placeholder="Maximum alarm level"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-4 col-form-label"
                    >Consumed Quantity</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.consumed_quantity"
                      class="form-control"
                      placeholder="Consumed Quantity"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">ROB</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.rob"
                      class="form-control"
                      placeholder="ROB"
                    />
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">New Items</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.new_items"
                      class="form-control"
                      placeholder="New Items"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label"
                    >Reconditiond Items</label
                  >
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.reconditioned_items"
                      class="form-control"
                      placeholder="Reconditiond Items"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-md-4">
                <div class="row mb-3">
                  <label class="col-sm-2 col-form-label">ROB</label>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      v-model="form.rob"
                      class="form-control"
                      placeholder="ROB"
                    />
                  </div>
                </div>
              </div> -->

              <div class="col-md-4">
                <div class="row mb-1">
                  <label class="col-sm-12 col-form-label"
                    >Is Tracker Item</label
                  >
                  <div class="form-check form-switch mb-2">
                    <input
                      type="checkbox"
                      v-model="form.is_tracked_item"
                      class="form-check-input"
                      id="formSwitch6"
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <h4>
              <i class="link-arrow" data-feather="edit"></i>Alternate Part
              Numbers
            </h4>
            <hr />
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Part Number</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <loading-table
                    :isLoading="isLoading"
                    cols="11"
                  ></loading-table>
                  <tr v-if="form.spare_part_numbers.length == 0">
                    <td colspan="11" class="text-center">No data Found</td>
                  </tr>
                  <tr
                    v-for="(spare_part_number, ar) in form.spare_part_numbers"
                    :key="`spare_part_number${ar}`"
                  >
                    <td>{{ ar + 1 }}.</td>
                    <td>
                      <input
                        v-uppercase
                        type="text"
                        class="form-control"
                        placeholder="Part Number"
                        v-model="spare_part_number.part_number"
                      />
                    </td>

                    <td>
                      <div class="text-center">
                        <button
                          class="btn btn-danger btn-sm"
                          @click="deletePartNumber(spare_part_number)"
                          v-if="!spare_part_number.id"
                        >
                          Delete
                        </button>
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_part_number_data(spare_part_number.id)"
                          v-else
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="form.spare_part_numbers">
                    <td
                      colspan="11"
                      align="center"
                      @click="addEmptyPartNumber()"
                      style="
                        background-color: #6571ff;
                        color: white;
                        border-radius: 10px;
                        box-shadow: none;
                      "
                    >
                      Add New Row
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";

export default {
  name: "Spare PartCreate",
  data() {
    return {
      form: {
        vessel_id: "",
        measure_id: "",
        location_on_board_id: "",
        machinaery_group_id: "",
        related_machinary_id: "",
        spare_part_numbers: [],
      },
      vessels: [],
      measures: [],
      location_on_boards: [],
      machinaryGroups: [],
      relatedMachinaries: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("spare_parts/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      masters.measures.forEach((measure) => {
        this.measures.push({
          id: measure.id,
          name: measure.name,
        });
      });
      masters.location_on_boards.forEach((location_on_board) => {
        this.location_on_boards.push({
          id: location_on_board.id,
          name: location_on_board.name,
        });
      });
      masters.machinaery_groups.forEach((MG) => {
        this.machinaryGroups.push({
          id: MG.id,
          name: MG.name,
        });
      });
      masters.related_machinaries.forEach((RM) => {
        this.relatedMachinaries.push({
          id: RM.id,
          name: RM.name,
        });
      });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/spare_parts", this.form);
        this.isLoading = false;
        this.$router.push("/planned-maintenance/spare-parts");
      } catch (e) {
        this.isLoading = false;
      }
    },
    deletePartNumber(bankDetail) {
      this.form.spare_part_numbers = this.form.spare_part_numbers.filter(
        (ar) => ar != bankDetail
      );
    },
    addEmptyPartNumber() {
      this.form.spare_part_numbers.push({
        // supplier_detail_id: this.form.id,
        company_id: this.company.id,
        part_number: "",
      });
    },
    async delete_part_number_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=spare_part_numbers`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
